<template>
	<Modal v-model="modalVisible" :width="1200" scrollable class-name="vertical-center-modal"
		@on-visible-change="onVisibleChange">
		<p slot="header">
			<span>产品编辑</span>
			<span v-if="formEditMode === FORM_EDIT_MODE_MODIFY"
				style="margin-left:20px;color:blue;">{{productForm.productCode}}</span>
		</p>
		<Spin v-if="innerSpin" size="large" fix></Spin>
		<div style="height:500px;overflow:scroll;padding-left:20px;padding-right:20px;">
			<Form ref="productForm" :model="productForm" :rules="ruleValidate" label-position="top" class="small-form">

				<Divider orientation="left" size="small">产品信息</Divider>
				<div class="productInfoWrap">
					<Row :gutter="16">
						<Col span="4">
						<FormItem label="名称" prop="productName">
							<Input v-model="productForm.productName"></Input>
						</FormItem>
						</Col>

						<Col span="4">
						<FormItem label="大类" prop="productMainCategoryUuid">
							<Select v-model="productForm.productMainCategoryUuid" transfer>
								<Option v-for="item in popupEditResource.mainCategorySource"
									:key="item.mainCategoryUuid" :value="item.mainCategoryUuid">
									{{ item.mainCategoryName }}
								</Option>
							</Select>
						</FormItem>
						</Col>

						<Col span="4">
						<FormItem label="小类" prop="productSubCategoryUuid">
							<Select v-model="productForm.productSubCategoryUuid" filterable transfer>
								<Option v-for="item in subCategorySource" :key="item.subCategoryUuid"
									:value="item.subCategoryUuid">{{ item.subCategoryName }} {{ item.brand }}</Option>
							</Select>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="产品形态" prop="productForm">
							<Select v-model="productForm.productForm" transfer>
								<Option v-for="ft in formOptions" :key="ft" :value="ft">{{ ft }}</Option>
							</Select>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="品牌" prop="productBrandUuid">
							<Select v-model="productForm.productBrandUuid" disabled filterable transfer>
								<Option v-for="item in popupEditResource.brandSource" :key="item.brandUuid"
									:value="item.brandUuid">{{ item.brandName }}</Option>
							</Select>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="颜色" prop="productColor">
							<Input v-model="productForm.productColor"></Input>
						</FormItem>
						</Col>

					</Row>
					<Row :gutter="16">
						<Col span="4">
						<FormItem prop="productPackageUuid">
							<span slot="label">纸箱</span>
							<Select v-model="productForm.productPackageUuid" filterable transfer>
								<Option v-for="item in popupEditResource.packageSource" :key="item.packageUuid"
									:value="item.packageUuid">{{ item.packageName + ' ' + item.packageRemark }}</Option>
							</Select>
						</FormItem>
						</Col>

						<Col span="4">
						<FormItem label="装箱量" prop="productPackageQuantity">
							<integer-input :min="1" :max="1000000" v-model="productForm.productPackageQuantity" />
						</FormItem>
						</Col>

						<Col span="4">
						<FormItem label="单位" prop="productUnitUuid">
							<Select v-model="productForm.productUnitUuid" filterable transfer>
								<Option v-for="item in popupEditResource.unitSource" :key="item.unitUuid"
									:value="item.unitUuid">{{ item.unitName }}</Option>
							</Select>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="规格">
							<Input v-model="productForm.productSpec"></Input>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="包装费(箱/元)" prop="packingFee">
							<Input v-model="productForm.packingFee"></Input>
						</FormItem>
						</Col>

						<Col span="4">
						<FormItem label="配送费(箱/元)" prop="deliveryFee">
							<Input v-model="productForm.deliveryFee"></Input>
						</FormItem>
						</Col>
					</Row>

					<!-- 新增包装费、配送费 -->
					<Row :gutter="16">
						<Col span="4">
						<FormItem label="最小单位指标" prop="productIncreaseStepAmount">
							<decimal-input v-model="productForm.productIncreaseStepAmount" :precision="0" />
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="最低起订量" prop="productMinOrderAmount">
							<decimal-input v-model="productForm.productMinOrderAmount" :precision="0" />
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="定金比例(%)" prop="productPreSaleDepositRatio">
							<integer-input v-model="productForm.productPreSaleDepositRatio" :min="0" :max="100" />
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="系列" prop="productSerialUuid">
							<Select v-model="productForm.productSerialUuid" filterable transfer>
								<Option v-for="item in popupEditResource.serialSource" :key="item.serialUuid"
									:value="item.serialUuid">{{ item.serialName }} {{item.brand}}</Option>
							</Select>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="苗高(cm)" prop="seedlingHeight">
							<Input v-model="productForm.seedlingHeight"></Input>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="对叶数" prop="leavesNumber">
							<Input v-model="productForm.leavesNumber"></Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="16">
						<Col span="4">
						<FormItem label="盘数(如100穴/盘)" prop="pottingSeedling">
							<integer-input v-model="productForm.pottingSeedling" :min="0" class="width50" />
                            <Select v-model="productForm.pottingSeedlingUnit" filterable transfer class="width50">
                                <Option v-for="item in pottingSeedlingUnit" :key="item"
                                    :value="item">{{ item }}</Option>
                            </Select>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="16" v-if="$checkAccessArray(['B'])">
						<Col span="16">
						<div style="font-size: 12px;color:red;padding:5px 0px;">
							温馨提示：为确保客户端图片显示效果良好,请上传宽高比为1:1.1的图片（如宽750px-高825px）
						</div>
						</Col>
					</Row>
					<Row :gutter="16">
						<Col span="4">
						<FormItem label="成品图" prop="productFinishImageFile">
							<div class="img-card">
								<single-file-upload-with-name v-model="productForm.productFinishImageFile" :imgHeight="150"
									:imgWidth="150" />
								<Icon type="md-trash" class="icon-delete" @click="deleteFinishImageFile()" v-if="productForm.productFinishImageFile!=''&& productForm.productFinishImageFile!=null"/>
							</div>
						</FormItem>
						</Col>

						<Col span="4">
						<FormItem label="种苗图">
							<div class="img-card">
								<single-file-upload-with-name v-model="productForm.productSeedImageFile" :imgHeight="150"
									:imgWidth="150" />
								<Icon type="md-trash" class="icon-delete" @click="deleteSeedImageFile()" v-if="productForm.productSeedImageFile!=''&& productForm.productSeedImageFile!=null"/>
							</div>
						</FormItem>
						</Col>

						<Col span="4">
						<FormItem label="盘苗图">
							<div class="img-card">
								<single-file-upload-with-name v-model="productForm.productTraySeedImageFile"
									:imgHeight="150" :imgWidth="150" />
								<Icon type="md-trash" class="icon-delete" @click="deleteTraySeedImageFile()" v-if="productForm.productTraySeedImageFile!=''&& productForm.productTraySeedImageFile!=null"/>
							</div>
						</FormItem>
						</Col>

						<Col span="4">
						<FormItem label="包装图">
							<div class="img-card">
								<single-file-upload-with-name v-model="productForm.productPackImageFile" :imgHeight="150"
									:imgWidth="150" />
								<Icon type="md-trash" class="icon-delete" @click="deletePackImageFile()" v-if="productForm.productPackImageFile!=''&& productForm.productPackImageFile!=null"/>
							</div>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="标准卡图">
							<div class="img-card">
								<single-file-upload-with-name v-model="productForm.productStandardImageFile"
									:imgHeight="150" :imgWidth="150" />
								<Icon type="md-trash" class="icon-delete" @click="deleteStandardImageFile()" v-if="productForm.productStandardImageFile!=''&& productForm.productStandardImageFile!=null"/>
							</div>
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="前端显示图" prop="productFontImageIndex">
							<Select v-model="productForm.productFontImageIndex" transfer>
								<Option :value="1">成品图</Option>
								<Option :value="2">种苗图</Option>
								<Option :value="3">盘苗图</Option>
								<Option :value="4">包装图</Option>
								<Option :value="5">标准卡图</Option>
							</Select>
						</FormItem>
						</Col>
					</Row>
					<Row>
						<Col span="24">
						<FormItem label="示范视频">
							<template>
							    <Upload action="https://up-z2.qiniup.com/"
							            :data="uploadParams"
							            :format="['mp4']"
							            accept=".mp4"
							            :on-format-error ="handleFormatError"
							            :on-success="handleUploadVideoSuccess"
							            :before-upload="beforeVideoUpload"
							            :show-upload-list="showUploadList"
							            v-if="readonly == false && demonVideos.length <5"
							    >
							        <Button icon="ios-cloud-upload-outline">上传视频</Button>
							    </Upload>
							
							    <Row :gutter="16" style="margin-top: 10px;">
							        <Col span="5" v-for="(item, index) in demonVideos" :key="index">
							            <div class="img-card">
											<video width="150" height="150" controls>
											    <source :src="item.src" type="video/mp4">
											</video>
							                <Icon type="md-trash" class="icon-delete" @click="deleteVideo(index)" v-if="readonly == false"/>
							            </div>
							        </Col>
							    </Row>
							</template>
						</FormItem>
						</Col>
						<!-- <Col span="4">
						<FormItem label="示范视频2">
							<single-file-upload-with-name v-model="productForm.demonstrationVideo2" :imgHeight="150"
								:imgWidth="150" />
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="示范视频3">
							<single-file-upload-with-name v-model="productForm.demonstrationVideo3" :imgHeight="150"
								:imgWidth="150" />
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="示范视频4">
							<single-file-upload-with-name v-model="productForm.demonstrationVideo4" :imgHeight="150"
								:imgWidth="150" />
						</FormItem>
						</Col>
						<Col span="4">
						<FormItem label="示范视频5">
							<single-file-upload-with-name v-model="productForm.demonstrationVideo5" :imgHeight="150"
								:imgWidth="150" />
						</FormItem>
						</Col> -->
					</Row>
				</div>

				<Divider orientation="left" size="small">说明信息</Divider>
				<div>
					<Row :gutter="16">
						<Col span="12">
						<FormItem label="特别通告">
							<Input v-model="productForm.productOtherSpec" type="textarea">
							</Input>
						</FormItem>
						</Col>
						<Col span="12">
						<FormItem label="品种特征">
							<Input v-model="productForm.productfeatures" type="textarea">
							</Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="16">
						<Col span="12">
						<FormItem label="栽培技术" prop="productCultivation">
							<Input v-model="productForm.productCultivation" type="textarea">
							</Input>
						</FormItem>
						</Col>
						<Col span="12">
						<FormItem label="常见问题">
							<Input v-model="productForm.productCommonProblem" type="textarea">
							</Input>
						</FormItem>
						</Col>
					</Row>
					<Row :gutter="16">
						<Col span="12">
						<FormItem label="关于售后">
							<Input v-model="productForm.afterService" type="textarea">
							</Input>
						</FormItem>
						</Col>
						<Col span="12">
						<FormItem label="优惠政策">
							<Input v-model="productForm.discountPolicy" type="textarea">
							</Input>
						</FormItem>
						</Col>
					</Row>
				</div>
				<Divider orientation="left" size="small">个性合同</Divider>
				<div>
					<Row :gutter="16">
						<Col span="24">
						<Input v-model="productForm.productFeatureContract" :rows="5" type="textarea">
						</Input>
						</Col>
					</Row>
				</div>
			</Form>
		</div>
		<div slot="footer">
			<ButtonGroup>
				<Button v-if="this.$checkAccessArray(['B', 'C'])" :disabled="readonly" type="primary"
					@click="onSubmit">保存</Button>

				<Button v-if="$checkAccessArray(['B', 'C'])" type="error" style="margin-left: 10px;"
					@click="onDelete">删除</Button>

				<Button type="default" style="margin-left: 10px;" @click="onCancel">取消</Button>
			</ButtonGroup>

		</div>
        
	</Modal>
</template>

<script>
import {
    PRODUCT_APPROVAL_INREVIEW,
    PRODUCT_APPROVAL_NO,
    PRODUCT_APPROVAL_YES
} from '@/view/product-management/product-management/ProductApproveDefine';
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from '@/view/mixins/form-edit-mode';

import ModalVisible from '@/view/mixins/modal-visible';
import IntegerInput from '@/components/number-input/integer-input';
import DecimalInput from '@/components/number-input/decimal-input';
import SingleFileUploadWithName from '@/components/single-file-upload-with-name/SingleFileUploadWithName';
import ImageCut from '@/components/image-cut/ImageCut';
import {
    getImageSrc
} from '@/libs/tableRowImageRender';

import {
    getProductDetail,
    saveProduct,
    deleteProduct,
    qiniuToken
} from '@/api/modules/product-management/product-management';
import {
    saveProductApprove
} from '@/api/modules/product-management/productApprove-management';
import { TabPane } from 'iview';

export default {
    name: 'ProductPopupEdit',
    components: {
        IntegerInput,
        SingleFileUploadWithName,
        DecimalInput,
        ImageCut
    },
    mixins: [ModalVisible],
    props: {
        productUuid: {
            type: String,
            required: true,
            default: ''
        },
        popupEditResource: {
            type: Object,
            required: true,
            default() {
                return {
                    seedFarmCode: '',
                    mainCategorySource: [],
                    rawSubCategorySource: [],
                    brandSource: [],
                    serialSource: [],
                    unitSource: [],
                    packageSource: [],
                    masterSource: [],
                    allRegionInfo: [],
                    approvalSource: [],
                    packingFee: '',
                    deliveryFee: '',
                    // productCategoryFeature: '',
                    productCultivation: 0,
                    demonstrationVideo2: 0,
                    demonstrationVideo3: 0,
                    demonstrationVideo4: 0,
                    demonstrationVideo5: 0,
                    discountPolicy: 0,
                    productPreSaleDiscountRatio: 0,
                    productFeatureContract: '',
                    pottingSeedling:0,
                    seedlingHeight:'',
                    leavesNumber:''
                };
            }
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        const productInitForm = this.getProductInit();

        return {
            imageDomain: this.imageDomain,
            demonVideos: [],
            showUploadList: false,
            uploadParams: {},
            innerSpin: false,
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            formOptions: ['种苗', '种条', '种球', '种子', '组培苗', '半成品', '其他'],
            stationOptions: ['广州站', '岭南站', '北京站', '深圳站', '其他'],
            productTagsList: [{
                value: 'distributionStationName',
                label: '站点'
            }, {
                value: 'productCode',
                label: '编码'
            }, {
                value: 'productName',
                label: '名称'
            }, {
                value: 'productPackageQuantity',
                label: '装箱量'
            },
            {
                value: 'productUnitUuid',
                label: '单位'
            },
            {
                value: 'productPackageUuid',
                label: '纸箱'
            },
            {
                value: 'productSpec',
                label: '规格'
            }
            ],
            productForm: productInitForm,
            ruleValidate: {
                productMainCategoryUuid: [{
                    required: true,
                    message: '大类不能为空',
                    trigger: 'blur'
                }],
                productSubCategoryUuid: [{
                    required: true,
                    message: '小类不能为空',
                    trigger: 'blur'
                }],
                productBrandUuid: [{
                    required: true,
                    message: '品牌不能为空',
                    trigger: 'blur'
                }],
                productName: [{
                    required: true,
                    message: '名称不能为空',
                    trigger: 'blur'
                }],
                productUnitUuid: [{
                    required: true,
                    message: '单位不能为空',
                    trigger: 'blur'
                }],
                productForm: [{
                    required: true,
                    message: ' ',
                    trigger: 'blur'
                }],
                productPackageUuid: [{
                    required: true,
                    message: ' ',
                    trigger: 'blur'
                }],
                productPackageQuantity: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '装箱量不能为空',
                    trigger: 'blur'
                }],
                packingFee: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '包装费不能为空',
                    trigger: 'blur'
                }],
                deliveryFee: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '配送费不能为空',
                    trigger: 'blur'
                }],
                productFinishImageFile: [{
                    required: true,
                    message: '成品图不能为空',
                    trigger: 'blur'
                }],
                productIncreaseStepAmount: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '最小单位指标不能为空',
                    trigger: 'blur'
                }],
                productMinOrderAmount: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '最小起订量不能为空',
                    trigger: 'blur'
                }],
                seedlingHeight: [{
                    required: true,
                    message: '苗高不能为空',
                    trigger: 'blur'
                }],
                leavesNumber: [{
                    required: true,
                    message: '对叶数不能为空',
                    trigger: 'blur'
                }],
                pottingSeedling: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '盘数不能为空',
                    trigger: 'blur'
                }],
                productPreSaleDepositRatio: [{
                    required: true,
                    validator: this.validateNumber,
                    message: '定金比例不能为空 ',
                    trigger: 'blur'
                }],
                // productCategoryFeature: [{
                // 	required: true,
                // 	message: '常见问题不能为空',
                // 	trigger: 'blur'
                // }],
                productCultivation: [{
                    required: true,
                    message: '栽培技术不能为空',
                    trigger: 'blur'
                }],
                //demonstrationVideo: [{ required: true, message: '示范视频不能为空', trigger: 'blur' }],
                //discountPolicy: [{ required: true, message: '优惠政策不能为空', trigger: 'blur' }],
                productColor: [{
                    required: true,
                    message: '颜色不能为空',
                    trigger: 'blur'
                }],
                productSerialUuid: [{
                    required: true,
                    message: ' ',
                    trigger: 'blur'
                }]
            },
            subCategoryRelateMaster: {
                name: ''
            },
            subCategorySource: [],
            commissionForm: {
                provinceUuid: '',
                cityUuid: '',
                distUuid: '',
                commission: 0,
                commissionType: '预售'
            },
            provinceOptions: [],
            cityOptions: [],
            distOptions: [],
            pottingSeedlingUnit: ['盘', '袋', '盒', '筐', '箱']
        };
    },
    computed: {
        productIsApproval() {
            return this.productForm.productApproval === PRODUCT_APPROVAL_INREVIEW
					|| this.productForm.productApproval === PRODUCT_APPROVAL_YES;
        }
    },
    watch: {
        productUuid: {
            deep: true,
            immediate: true,
            handler: function (newValue) {
                this.formEditMode = newValue === '' ? FORM_EDIT_MODE_CREATE : FORM_EDIT_MODE_MODIFY;
                if (newValue === '') {
                    this.productForm = this.getProductInit();
                }
                else {
                    this.$refs.productForm.resetFields();
                }
            }
        },
        'productForm.productMainCategoryUuid': {
            deep: true,
            immediate: true,
            handler: function (newVal) {
                this.subCategorySource = [];
                if (newVal !== '') {
                    this.subCategorySource = this.popupEditResource.rawSubCategorySource.filter(item => item
                        .subCategoryMainUuid === newVal);
                }

                if (this.productForm.productSubCategoryUuid !== '') {
                    const find = this.subCategorySource.find(item => item.subCategoryUuid === this.productForm
                        .productSubCategoryUuid);
                    if (!find) {
                        this.productForm.productSubCategoryUuid = '';
                        this.subCategoryRelateMaster.name = '';
                        this.subCategoryRelateMaster.phone = '';
                    }
                }
            }
        },
        'productForm.productSubCategoryUuid': {
            deep: true,
            immediate: true,
            handler: function (newVal) {

                this.productForm.productRelateMasterLoginUuid = '';
                if (newVal !== '') {
                    const subCategory = this.popupEditResource.rawSubCategorySource.find(item => item
                        .subCategoryUuid === newVal);
                    if (subCategory) {
                        this.productForm.productRelateMasterLoginUuid = subCategory
                            .subCategoryRelateMasterLoginUuid;

                        this.subCategoryRelateMaster.name = '';
                        this.subCategoryRelateMaster.phone = '';

                        const findMaster = this.popupEditResource.masterSource.find(m => m.userMasterLoginUuid
								=== subCategory.subCategoryRelateMasterLoginUuid);
                        if (findMaster) {
                            this.subCategoryRelateMaster.name = findMaster.userMasterName;
                            this.subCategoryRelateMaster.phone = findMaster.userMasterPhone;
                        }
                    }
                }
            }
        }
    },
    methods: {
        deleteFinishImageFile(){
            this.$Modal.confirm({
				    title: '确认',
				    content: '是否删除成品图？',
				    onOk: () => {
				        this.productForm.productFinishImageFile='';
				    }
            });
        },
        deleteSeedImageFile(){
            this.$Modal.confirm({
				    title: '确认',
				    content: '是否删除种苗图？',
				    onOk: () => {
				        this.productForm.productSeedImageFile='';
				    }
            });
        },
        deleteTraySeedImageFile(){
            this.$Modal.confirm({
				    title: '确认',
				    content: '是否删除盘苗图？',
				    onOk: () => {
				        this.productForm.productTraySeedImageFile='';
				    }
            });
        },
        deletePackImageFile(){
            this.$Modal.confirm({
				    title: '确认',
				    content: '是否删除包装图？',
				    onOk: () => {
				        this.productForm.productPackImageFile='';
				    }
            });
        },
        deleteStandardImageFile(){
            this.$Modal.confirm({
				    title: '确认',
				    content: '是否删除标准卡图？',
				    onOk: () => {
				        this.productForm.productStandardImageFile='';
				    }
            });
        },
        handleFormatError(request, file) {
			    this.$Notice.warning({
			        title: '格式错误',
			        desc: '请上传mp4格式文件'
			    });
        },
        async beforeVideoUpload(request) {
			    // **注意这里的参数必须通过属性赋值，如果直接修改整个uploadParams是无效的。**
			    // 上传之前设置上传参数,
			    let suffix = request.name.substring(request.name.lastIndexOf("."));
			    let filename = Date.now() + Math.random().toString(36).slice(2) + suffix;
			    await qiniuToken({}).then(res => {
			        this.uploadParams.token = res.data.token;
			        // 七牛response hash key的值自定义，后面如果需要浏览或者下载都需要这个地址，如果key不定义，那么七牛生成的key === hash的值
			        this.uploadParams.key = filename;
			    });
        },
        handleUploadVideoSuccess(request, file, list) {
			    let videoPath = this.imageDomain + file.response.key;
			    this.demonVideos.push({ id: '', src: videoPath, size: file.size });
        },
        // 删除视频
        deleteVideo(index) {
			    this.$Modal.confirm({
			        title: '确认',
			        content: '是否删除视频？',
			        onOk: () => {
			            this.demonVideos.splice(index, 1);
			        }
			    });
        },
        validateNumber(rule, value, callback) {
            if (/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(value)) {
                callback();
            }
            else {
                return callback(new Error());
            }
        },
        getProductInit() {
            return {
                productUuid: '',
                productMainCategoryUuid: '',
                productSubCategoryUuid: '',
                productRelateMasterLoginUuid: '',
                productBrandUuid: '',
                productCode: '',
                productName: '',
                productAlias: '',
                productUnitUuid: '',
                productPackageUuid: '',
                productPackageQuantity: 1,
                productSpec: '',
                packingFee: 0,
                deliveryFee: 0,
                productFinishImageFile: '',
                productSeedImageFile: '',
                demonstrationVideo: '',
                demonstrationVideo2: '',
                demonstrationVideo3: '',
                demonstrationVideo4: '',
                demonstrationVideo5: '',
                //优惠政策
                discountPolicy: '',
                productTraySeedImageFile: '',
                productPackImageFile: '',
                productStandardImageFile: '',
                productCategoryFeature: '',
                //栽培技术
                productCultivation: '',
                //特别通告
                productOtherSpec: '',
                //品种特征
                productfeatures:'',
                //关于售后
                afterService: '',
                productApproval: PRODUCT_APPROVAL_NO,
                productMinOrderAmount: 0,
                productIncreaseStepAmount: 0,
                productPreSaleDepositRatio: 20,
                productCurSaleDepositRatio: 20,
                productColor: '',
                productLeadTime: 60,
                productForm: '',
                productFontImageIndex: 1,
                productPreSaleDiscountRatio: 0,
                distributionStationName: '',
                productTags: '',
                productSerialUuid: '',
                seedlingHeight:0,
                leavesNumber:0,
                pottingSeedling:0,
                //常见问题
                productCommonProblem:''
            };
        },
        onVisibleChange(visible) {
            if (this.popupEditResource.brandSource.length > 0) {
                this.productForm.productBrandUuid = this.popupEditResource.brandSource[0].brandUuid;
            }

            if (visible && this.productUuid !== '') {
                this.demonVideos=[];
                getProductDetail(this.productUuid).then(res => {
                    const info = res.data.product;
                    const commissions = res.data.commissions;
                    this.productApproveDetail = res.data.productApproveDetail;

                    this.productForm = Object.assign(this.productForm, info);
                    if(this.productForm.demonstrationVideo){
                        let videosArr=this.productForm.demonstrationVideo.split(',');
                        videosArr.forEach(item =>{
                            this.demonVideos.push({ id: '', src: this.imageDomain +item, size: 0 });
                        });
                    }
						
                    this.productForm.productMainCategoryUuid = info.productMainCategoryUuid;
                    this.productForm.productSubCategoryUuid = info.productSubCategoryUuid;

                    this.provinceOptions = this.popupEditResource.allRegionInfo.filter(r => r.regionType
							=== 1);
                });
            }
        },
        onShowImage(image) {
            const imageSrc = getImageSrc(image);
            if (imageSrc) {
                window.open(imageSrc);
            }
        },
        onProvinceChange(provinceUuid) {
            this.commissionForm.distUuid = '';
            this.distOptions = [];

            this.commissionForm.cityUuid = '';
            this.cityOptions = this.popupEditResource.allRegionInfo.filter(r => r.regionType === 2 && r
                .regionParentUuid === provinceUuid);
        },
        onCityChange(cityUuid) {
            this.commissionForm.distUuid = '';
            this.distOptions = this.popupEditResource.allRegionInfo.filter(r => r.regionType === 3 && r
                .regionParentUuid === cityUuid);
        },
        onCancel() {
            this.modalVisible = false;
        },
        onDelete() {
            this.$Modal.confirm({
                title: '确认删除该商品？',
                onOk: () => {
                    deleteProduct(this.productUuid).then(res => {
                        this.modalVisible = false;
                        this.$emit('on-popup-submit-finish');
                    });
                }
            });
        },
        onSubmit() {
            this.$refs.productForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('请将打*号的内容填写完整!');
                    return;
                }

                if(this.productForm.productMinOrderAmount < this.productForm.productIncreaseStepAmount){
                    this.$Message.error('最低起订量不能小于最小单位指标!');
                    return;
                }

                if (Number(this.productForm.productMinOrderAmount) % Number(this.productForm.productIncreaseStepAmount) != 0) {
                    this.$Message.error('最低起订量必须是最小单位指标的整数倍！');
                    return;
                }
                this.productForm.demonstrationVideo = '';
                if(this.demonVideos.length == 0) {
					    this.productForm.demonstrationVideo = '';
                }
                else {
                    this.demonVideos.forEach(item => {
                        if(this.productForm.demonstrationVideo == ''){
                            this.productForm.demonstrationVideo += item.src.replaceAll(this.imageDomain, '');
                        }
                        else{
                            this.productForm.demonstrationVideo += ',' + item.src.replaceAll(this.imageDomain, '');
                        }
                    });
                }

                const data = Object.assign({
                    formEditMode: this.formEditMode
                }, this.productForm);

                this.innerSpin = true;
                saveProduct(data).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            content: '',
                            onOk: () => {
                                this.modalVisible = false;
                                this.$emit('on-popup-submit-finish');
                            }
                        });
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            });
        },
        onSaveAndApproval() {
            this.$refs.productForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return false;
                }

                if(this.productForm.productMinOrderAmount < this.productForm.productIncreaseStepAmount){
                    this.$Message.error('最低起订量不能小于最小单位指标!');
                    return;
                }

                if (Number(this.productForm.productMinOrderAmount) % Number(this.productForm.productIncreaseStepAmount) != 0) {
                    this.$Message.error('最低起订量必须是最小单位指标的整数倍！');
                    return;
                }
					
                this.productForm.demonstrationVideo = '';
                if(this.demonVideos.length == 0) {
					    this.productForm.demonstrationVideo = '';
                }
                else {
                    this.demonVideos.forEach(item => {
                        if(this.productForm.demonstrationVideo == ''){
                            this.productForm.demonstrationVideo += item.src.replaceAll(this.imageDomain, '');
                        }
                        else{
                            this.productForm.demonstrationVideo += ',' + item.src.replaceAll(this.imageDomain, '');
                        }
                    });
                }

                const data = Object.assign({
                    formEditMode: this.formEditMode
                }, this.productForm);

                this.innerSpin = true;
                saveProduct(data).then(res => {
                    this.innerSpin = false;
                    if (res.code === 0) {
                        const product = res.data.product;
                        const productUuid = product.productUuid;
                        const productName = product.productName;
                        const productCode = product.productCode;

                        // 产品信息保存成功，并进行提交审批操作
                        const productApproval = {
                            productUuid: productUuid,
                            productTag: `${productName}（${productCode}）`,
                            productApproveDetailRequestRemark: '自动提交'
                        };

                        const approvalSubmit = {
                            products: [productApproval]
                        };

                        this.innerSpin = true;
                        saveProductApprove(approvalSubmit).then(r => {
                            this.innerSpin = false;
                            if (r.code === 0) {
                                this.$Modal.success({
                                    title: '保存并提交审批成功',
                                    onOk: () => {
                                        this.modalVisible = false;
                                        this.$emit('on-popup-submit-finish');
                                    }
                                });
                            }
                        }).catch(() => {
                            this.innerSpin = false;
                        });
                    }
                }).catch(() => {
                    this.innerSpin = false;
                });
            });
        }
    }
};
</script>

<style lang="less">
	.productInfoWrap .number-input .ivu-input-number-input{text-align: left !important;}
    .width50{width:50px;}
	.icon-delete {
	    font-size: 30px;
	    position: absolute;
	    top: 30px;
	    right: 2px;
	    background-color: rgba(255, 255, 255, 0.6);
	    border-radius: 50%;
	}
	
	.img-card {
	    position: relative;
	    width: 150px;
	    height: 150px;
	    margin-top: 10px;
	    overflow: hidden;
	}
</style>
